import React, { useState, useEffect } from "react";
import {
  Slideout,
  Typography,
  Tabs,
} from "@ann/web-components";
import {
  SlideoutWrapper,
  DocumentDetailSlideoutContainer,
  DocumentDetailSlideoutHeader,
  DocumentDetailSlideoutTabs,
} from "./DocumentDetailSlideout.styled";

import { ActivityContent} from "./pages/ActivityContent";
import { GeneralContent } from "./pages/GeneralContent";
import RenameDocumentModal from "../RenameDocumentModal/RenameDocumentModal";

const DocumentDetailSlideout = ({
  open,
  onClose,
  document,
  onRename,
  onShare,
  onManageAgent,
  onManageAccess,
  showActions = true,
  store, // ✅ Store para actualizar el documento después del rename
}) => {
  // ✅ Estado local para el modal de rename
  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
  const [documentName, setDocumentName] = useState(document?.name || document?.title || "Document Name");

  // ✅ Actualizar el nombre cuando cambia el documento
  useEffect(() => {
    setDocumentName(document?.name || document?.title || "Document Name");
  }, [document?.name, document?.title]);

  // ✅ Handler para abrir el modal de rename
  const handleOpenRenameModal = () => {
    setIsRenameModalOpen(true);
  };

  // ✅ Handler para cerrar el modal de rename
  const handleCloseRenameModal = () => {
    setIsRenameModalOpen(false);
  };

  // ✅ Handler para guardar el rename (similar a MyWorkspace)
  const handleSaveRenameDocument = (result) => {
    if (result?.success) {
      const newName = result.newName || result.updatedDocument?.name;
      const documentUuid =
        result.documentUuid ||
        result.updatedDocument?.documentUuid ||
        result.updatedDocument?.document_uuid ||
        document?.document_uuid ||
        document?.documentUuid ||
        document?.id;

      if (documentUuid && newName) {
        // Actualizar el nombre local en el slideout
        setDocumentName(newName);

        // Función helper para actualizar el nombre del documento
        const updateDocumentName = (doc) => {
          if (doc && typeof doc.setName === 'function') {
            doc.setName(newName);
          } else if (doc) {
            doc.name = newName;
          }
        };

        // Actualizar en el store si está disponible
        if (store) {
          const docInStore = store.documentList?.find(
            (doc) =>
              doc.document_uuid === documentUuid ||
              doc.documentUuid === documentUuid ||
              doc.id === documentUuid
          );

          if (docInStore) {
            updateDocumentName(docInStore);
            if (store.setDocumentInList) {
              store.setDocumentInList(docInStore);
            }
          }
        }

        // Actualizar el documento local si tiene setName
        if (document) {
          updateDocumentName(document);
        }

        // ✅ Cerrar el slideout después de guardar exitosamente
        if (onClose) {
          onClose();
        }
      }
    }
  };

  return (
    <SlideoutWrapper>
      <Slideout onClose={onClose} size="medium" open={open}>
        <DocumentDetailSlideoutContainer>
          <DocumentDetailSlideoutHeader>
            <Typography category="title" size="large" weight="bold">
              {documentName}
            </Typography>
          </DocumentDetailSlideoutHeader>

          <DocumentDetailSlideoutTabs data-tabs>
            <Tabs defaultIndex={0} size="medium">
              <Tabs.List>
                <Tabs.Tab index={0} size="small">
                  General
                </Tabs.Tab>
                <Tabs.Tab index={1} size="small">
                  Activity
                </Tabs.Tab>
              </Tabs.List>

              <Tabs.Panel index={0}>
                <GeneralContent
                    document={document}
                    onRename={() => {
                      onClose();
                      onRename && onRename(document);
                    }}
                    onShare={onShare}
                    showActions={showActions}
                    onManageAgent={onManageAgent}
                    onManageAccess={onManageAccess}
                    onCloseSlideout={onClose}
                />
              </Tabs.Panel>

              <Tabs.Panel index={1}>
               <ActivityContent/>
              </Tabs.Panel>
            </Tabs>
          </DocumentDetailSlideoutTabs>
        </DocumentDetailSlideoutContainer>
      </Slideout>

      {/* ✅ Modal de rename integrado en el slideout */}
      <RenameDocumentModal
        isOpen={isRenameModalOpen}
        onClose={handleCloseRenameModal}
        onSave={handleSaveRenameDocument}
        documentUuid={
          document?.document_uuid ||
          document?.documentUuid ||
          document?.id
        }
        initialName={document?.name || ''}
      />
    </SlideoutWrapper>
  );
}

export default DocumentDetailSlideout;
